import styled, { css } from 'styled-components'

export const BoxButtons = styled('div')(
  ({ theme }) => css`
    position: sticky;
    bottom: 0;
    right: 0;
    display: flex;
    gap: ${theme.layout.gap.medium};
    justify-content: flex-end;
    width: 100%;
    padding: ${theme.layout.padding.medium};
    background-color: ${theme.colors.base.white};
    z-index: 1;

    @media (max-width: ${theme.screen.small}) {
      justify-content: space-between;
    }
  `
)
